module.exports = __webpack_public_path__ + "img/expanded_junayed_ahmed.20b02103.png";